import { makeStyles } from '@material-ui/styles'

export const useAddEditEventStyles = makeStyles({
  sectionTitle: {
    fontFamily: 'Nunito',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.5px',
    marginBottom: '5px',
    '&$noMargin': {
      marginBottom: 0,
    },
    '&~ $sectionTitle': {
      marginTop: '14px',
    },
  },
  subSection: {
    '& $dateTimePickers, & $subItem': {
      marginLeft: '40px',
      maxWidth: 'calc(100% - 40px)',
    },
    '& $subDropdown': {
      marginLeft: '12px',
      maxWidth: 'calc(100% - 12px)',
    },
  },
  subItem: {},
  subDropdown: {},
  noMargin: {},
  sectionWithGap: {},
  dateTimePickers: {
    display: 'flex',
    gap: '24px',
    width: '440px',
  },
  dateTimePicker: {
    width: '208px',
  },
  section: {
    gap: '10px',
    display: 'flex',
    flexDirection: 'column',
    '&:last-child': {
      marginBottom: '14px',
    },
  },
  switch: {
    display: 'flex',
    margin: '0 0 10px 4px',
    gap: '5px',
    '& > span': {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '16px',
      letterSpacing: '0.4px',
      color: '#000000',
    },
  },
  roleRow: {
    width: '100%',
    marginBottom: '10px',
  },
  roleRowDragging: {
    opacity: 1,
    background: '#F8FAFF',
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF',
    },
  },
  rolesDropContainer: {
    display: 'block',
    width: '100%',
    position: 'relative',
  },
  role: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: '10px',
    alignItems: 'center',
  },
  roleDragHandle: {
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    padding: '4px',
    cursor: 'grab',
    color: '#74777F',
  },
  roleSelector: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  roleQuantity: {
    width: '112px',
    flexShrink: 0,
  },
  roleDelete: {
    cursor: 'pointer',
    flexShrink: 0,
  },
  addIcon: {
    fontSize: '16px',
    color: '#0F5DB5',
    marginRight: '8px',
  },
  rolesFooter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '16px',
    width: '100%',
  },
  allowMultipleRegistrationsCheckbox: {
    margin: 0,
    '& label': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontFamily: 'Nunito',
      fontSize: '13px',
      lineHeight: '16px',
      letterSpacing: '0.4px',
      cursor: 'pointer',
    },
  },
  dependentField: {
    marginLeft: '38px',
  },
  unGap: {
    marginTop: '-10px',
  },
  plusCodeInput: {
    marginTop: '12px',
  },
})
